export default {
  units: "miles",
  radius: 3958.7613
};